function veranlagungenComparator(a, b) {
    return a.startJahr - b.startJahr;
}

function calculateEndjahre(items) {
    items.sort(veranlagungenComparator);

    const numOfElements = items.length;
    if (numOfElements > 1) {
        for (let i = 0; i < numOfElements - 1; i++) {
            const a = items[i];
            const b = items[i + 1];

            if (a.startJahr === b.startJahr) {
                a.endJahr = b.startJahr;
            } else {
                a.endJahr = b.startJahr - 1;
            }
        }

        items.at(-1).endJahr = 3000;
    } else if (numOfElements === 1) {
        items[0].endJahr = 3000;
    }
}

function calculateZeitraumStrings(items) {
    items.map(item => item.zeitraum = "" + item.startJahr + " - " + item.endJahr);
}

/**
 * Berechnet die Endjahre sowie die Zeitraum-Strings für die Anzeige von Veranlagungen.
 * @param veranlagungen die Veranlagungen, für die die Berechnung durchgeführt wird
 */
export function processVeranlagungen(veranlagungen) {
    calculateEndjahre(veranlagungen);
    calculateZeitraumStrings(veranlagungen);

    const currentAbwasserbeseitigungspflichtiger = findCurrentAbwasserbeseitigungspflichtiger(veranlagungen);
    if (currentAbwasserbeseitigungspflichtiger) {
        currentAbwasserbeseitigungspflichtiger.zeitraum += " (aktuell)";
    }
}

/**
 * Findet den aktuellen Abwasserbeseitigungspflichtigen in einem Array von Veranlagungen.
 * @param veranlagungen die Veranlagungen
 * @returns {null|*} den aktuellen Abwasserbeseitigungspflichtigen
 */
export function findCurrentAbwasserbeseitigungspflichtiger(veranlagungen) {
    if (veranlagungen.length > 0) {
        veranlagungen.sort(veranlagungenComparator);
        return veranlagungen.at(-1);
    } else {
        return null;
    }
}
